import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Nav.css";
import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import DensityMediumIcon from "@mui/icons-material/DensityMedium";
import { Link } from "react-scroll";

/* ✅ Use the SVG as a React component; file must be at src/images/logo.svg */
import { ReactComponent as LogoMark } from "../images/logo.svg";

function Nav() {
  const navigate = useNavigate();
  const [state, setState] = useState({ left: false });

  useEffect(() => { AOS.init(); }, []);
  const goHome = () => navigate("/", { replace: true });
  const toggleDrawer = (open) => () => setState({ left: open });

  const drawerItems = [
    { label: "Our Story", to: "Story" },
    { label: "Patients First", to: "PatientsFirst" },
    { label: "Get in Touch", to: "Contact" },
    { label: "Register / Get Help", route: "/register" },
  ];

  const drawerList = (
    <Box role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)} sx={{ width: 260 }}>
      <List>
        {drawerItems.map((item) => (
          <ListItem key={item.label} disablePadding>
            <ListItemButton onClick={() => item.route && navigate(item.route)}>
              {item.to ? (
                <Link spy to={item.to} smooth className="drawer-link">
                  <ListItemText primary={item.label} />
                </Link>
              ) : (
                <ListItemText primary={item.label} />
              )}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
    </Box>
  );

  return (
    <div className="n-wrapper nav" id="Nav" data-aos="fade-down">
      <div className="n-left">
        <div className="brand" onClick={goHome} style={{ cursor: "pointer" }}>
          <LogoMark className="brand-logo" role="img" aria-label="Being Human Matters logo" />
          <div className="brand-text">
            <div className="n-name">Being Human Matters</div>
            <p className="sub-title">We help families fight Cancer!</p>
          </div>
        </div>
      </div>

      <div className="n-right">
        <div className="n-list">
          <ul>
            <Link spy to="Story" smooth><li className="n-li" onClick={goHome}>Our Story</li></Link>
            <Link spy to="PatientsFirst" smooth><li className="n-li" onClick={goHome}>Patients First</li></Link>
            <Link spy to="Contact" smooth><li className="n-li" onClick={goHome}>Get in Touch</li></Link>
            <li className="n-li" onClick={() => navigate("/register")} style={{ cursor: "pointer" }}>
              Register / Get Help
            </li>
          </ul>
        </div>

        <div className="n-right-mobile-view">
          <Button onClick={toggleDrawer(true)} style={{ color: "var(--text-heading)" }}>
            <DensityMediumIcon />
          </Button>
          <Drawer anchor="left" open={state.left} onClose={toggleDrawer(false)}>
            {drawerList}
          </Drawer>
        </div>
      </div>
    </div>
  );
}

export default Nav;
